import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderComponent } from 'src/app/main/header/header.component';
import { LoginService } from 'src/app/main/login/login.service';
import { UtilsService } from 'src/app/utils/utils.service';

@Component({
    selector: 'app-error-page',
    standalone: true,
    imports: [TranslateModule, HeaderComponent, NgIf],
    templateUrl: './error-page.component.html',
    styleUrl: './error-page.component.scss'
})
export class ErrorPageComponent {
    @Input() errorNumber: HttpPageErrorNumber;

    readonly errorImages = {
        401: 'assets/images/error-images/error-401.svg',
        403: 'assets/images/error-images/error-403.svg',
        404: 'assets/images/error-images/error-404.svg',
        500: 'assets/images/error-images/error-500.svg',
    };

    constructor(
        private readonly router: Router,
        private readonly utilsService: UtilsService,
        private readonly loginService: LoginService
    ) { }

    async navigateToHome(): Promise<void> {
        const referrerPath = await this.utilsService.getCurrentUserHomePath();
        void this.router.navigate([referrerPath]);
    }

    async navigateToLogin(): Promise<void> {
        await this.loginService.logout();
        void this.router.navigate(['login']);
    }

    showHomeButton(): boolean {
        return this.errorNumber === 403 || this.errorNumber === 404 || this.errorNumber === 500;
    }

    showLoginButton(): boolean {
        return this.errorNumber === 401 || this.errorNumber === 403 || this.errorNumber === 404 || this.errorNumber === 500;
    }
}

export type HttpPageErrorNumber = 401 | 403 | 404 | 500;
